import { render, staticRenderFns } from "./PricingTableMobile.vue?vue&type=template&id=3ca2f156&scoped=true&"
import script from "./PricingTableMobile.vue?vue&type=script&lang=js&"
export * from "./PricingTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./PricingTableMobile.vue?vue&type=style&index=0&id=3ca2f156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2f156",
  null
  
)

export default component.exports